import { UserType } from "generated/CoreApi_v1";

export enum CorePermissions {
  /**
   * Unidades Administrativas - Gerenciar Tipos.
   * Pode criar, editar, excluir tipos de units.
   */
  UnitTypesManage = "UnitTypesManage",

  /**
   * Unidades Administrativas - Gerenciar Tipos.
   * Pode criar, editar, excluir tipos de units.
   */
  UnitsManage = "UnitsManage",

  /**
   * Unidades Administrativas - Atualizar.
   * Altera dados do cadastro da Units existentes.
   */
  UnitsUpdate = "UnitsUpdate",

  /**
   * Unidades Administrativas - Selecionar
   * Permite que usuário selecione unidades administrativas para operações no sistema
   */
  UnitsSelect = "UnitsSelect",

  /**
   * Grupos - Gerenciar Estáticos.
   * Cria, edita e exclui grupos estáticos.
   */
  GroupsManageStatic = "GroupsManageStatic",

  /**
   * Grupos - Gerenciar Dinâmicos.
   * Cria, edita e exclui grupos dinâmicos
   */
  GroupsManageDynamic = "GroupsManageDynamic",

  /**
   * Grupos - Atualizar.
   * Edita grupos estáticos existentes, mas não pode juntar ou excluir grupos.
   */
  GroupsUpdate = "GroupsUpdate",

  /**
   * Grupos - Visualizar.
   * Visualiza e pode selecionar grupos.
   */
  GroupsView = "GroupsView",

  /**
   * Grupos - Visualizar Grupos Gerais.
   * Pode visualizar os grupos gerais: Todos / Usuários Internos / Usuários Externos.
   */
  GroupsViewGeneral = "GroupsViewGeneral",

  /**
   * Usuários - Gerenciar.
   * Pode criar usuários;
   * Pode atualizar qualquer informação do usuário, exceto informações confidenciais;
   * Pode excluir usuários.
   */
  UsersManage = "UsersManage",

  /**
   * Usuários - Atualizar
   * Pode atualizar qualquer informação de usuários existentes, exceto informações confidenciais;
   * Pode tornar usuários ativos/inativos;
   * Pode atualizar status de "ausente" do usuário.
   */
  UsersUpdate = "UsersUpdate",

  /**
   * Usuários - Atualizar Informações Confidenciais.
   * Pode ver e atualizar campos custom do usuário marcados como "confidenciais".
   */
  UsersUpdateConfidential = "UsersUpdateConfidential",

  /**
   * Usuários - Atualizar Informações Pessoais.
   * Pode (a partir do perfil de um usuário) atualizar foto, e-mail, telefones, data de nascimento,
   * endereços de redes sociais do usuário, credenciais, campos custom vinculados à área de exibição "informações pessoais".
   */
  ProfileUpdatePersonal = "ProfileUpdatePersonal",

  /**
   * Usuários - Atribuir Papel
   * Atribui Roles a usuários que consegue atualizar.
   * Se não tiver também a permissão "Usuários - Atualizar" ou "Usuários - Gerenciar" não conseguirá usar esta permissão.
   */
  UsersAssignRole = "UsersAssignRole",

  /**
   * Usuários - Selecionar.
   * Pode ver e selecionar usuário para operações no sistema.
   * Obs: qualquer pessoa com acesso a uma publicação ou interação feita por um usuário pode ver perfil deste usuário(com limitação de informações) independente de possuir esta permissão.
   */
  UsersView = "UsersView",

  /**
   * Usuários - Visualizar Informações Confidenciais.
   * Pode visualizar campos custom do usuário marcados como "confidenciais".
   */
  UsersViewConfidential = "UsersViewConfidential",

  /**
   * Usuários - Trocar Senha.
   * Pode trocar senha de usuários.
   */
  UsersChangePassword = "UsersChangePassword",

  /**
   * Usuários - Personificar.
   * Pode personificar um usuário(equivalente a login espião no P5).
   */
  UsersImpersonate = "UsersImpersonate",

  /**
   * Usuários - Indicar Especialistas.
   * Pode indicar usuários como especialistas em tópicos.
   */
  UsersAppointSpecialists = "UsersAppointSpecialists",

  /**
   * Pode bloquear/desbloquear usuários ou operar "assistente de ausência" de usuários
   */
  UsersBlockOrSetAbsence = "UsersBlockOrSetAbsence",

  /**
   * Perfil - Atualizar Local de Atuação.
   * Permite edição deste campo no cadastro ou perfil do usuário.
   */
  ProfileUpdateLocal = "ProfileUpdateLocal",

  /**
   * Perfil  - Atualizar Foto.
   * Permite edição deste campo no perfil do usuário.
   */
  ProfileUpdatePhoto = "ProfileUpdatePhoto",

  /**
   * Perfil - Atualizar Conhecimentos.
   * Permite editar estas informações no perfil do usuário.
   */
  ProfileUpdateKnowledge = "ProfileUpdateKnowledge",

  /**
   * Perfil - Atualizar Credenciais.
   * Permite editar estas informações no perfil do usuário.
   */
  ProfileUpdateCredentials = "ProfileUpdateCredentials",

  /**
   * Perfil - Arquivos de Prontuário - Gerenciar.
   * Permite adicionar, remover e visualizar arquivos de prontuário no perfil do usuário
  */
  ProfileManageFiles = "ProfileManageFiles",

  /**
   * Perfil - Arquivos de Prontuário - Adicionar.
   * Permite adicionar e visualizar arquivos de prontuário no perfil do usuário, mas não removê-los.
  */
  ProfileAddFiles = "ProfileAddFiles",

  /**
   * Perfil - Arquivos de Prontuário - Visualizar.
   * Permite visualizar arquivos de prontuário no perfil do usuário.
  */
  ProfileViewFiles = "ProfileViewFiles",

  /**
   * Perfil  - Atualizar Nome.
   * Permite atualizar nome completo e nome de exibição do usuário
   */
  ProfileUpdateName = "ProfileUpdateName",

  /**
   * Perfil - Trocar Própria Senha
   * Permite trocar a senha no perfil do usuário
   */
  ProfileChangePassword = "ProfileChangePassword",

  /**
   * Calendário - Gerenciar.
   * Adiciona, Atualiza e Exclui calendários.
   */
  CalendarManage = "CalendarManage",

  /**
   * Horários de Acesso - Gerenciar.
   * Pode criar, atualizar e excluir regras de acesso ao sistema e calendários de feriados;
   * Pode incluir / excluir usuários e grupos nas regras de acesso ao sistema.
   */
  AccessHoursManage = "AccessHoursManage",

  /**
   * Campos Customizados - Gerenciar.
   * Pode criar, atualizar ou excluir campos custom.
   */
  CustomFieldsManage = "CustomFieldsManage",

  /**
   * Tópicos - Gerenciar.
   * Cria, Atualiza, Junta ou Exclui tópicos.
   */
  TopicsManage = "TopicsManage",

  /**
   * Pode vincular usuários ao tópico de forma obrigatório ou opcional.
   */
  TopicsLinkUsers = "TopicsLinkUsers",


  /**
   * Pode gerenciar vinculações dinâmicas de usuários a tópicos.
   */
  TopicsLinkUsersDynamic = "TopicsLinkUsersDynamic",

  /**
   * Stickers - Gerenciar.
   * Cria, Atualiza, ou Exclui Stickers.
   */
  StickersManage = "StickersManage",

  /**
   * Papéis - Gerenciar.
   * Cria, atualiza e exclui Roles.
   * Atribui qualquer Role a usuários e grupos(incluindo Roles com atribuição restrita).
   */
  SecurityRolesManage = "SecurityRolesManage",

  /**
   * Tags - Gerenciar.
   * Cria, Atualiza, Junta ou Exclui Tags.
   */
  TagsManage = "TagsManage",

  /**
   * Tags - Gerenciar Lista Negra.
   * Adiciona e Exclui tags da lista negra.
   */
  TagsBlackListManage = "TagsBlackListManage",

  /**
   * Interesses Pessoais - Criar
   * Pode criar novos interesses pessoais para vinculação a usuários.
   */
  TagsPersonalInterestCreate = "TagsPersonalInterestCreate",

  /**
   * Banners - Gerenciar.
   * Adiciona, Atualiza e Exclui Banners.
   */
  BannersManage = "BannersManage",

  /**
   * Notificações - Modelos de e-Mail - Gerenciar.
   * Edita modelos de e-mail para notificações, podendo alterar assunto, cabeçalho ou rodapé.
   */
  NotificationEmailTemplatesManage = "NotificationEmailTemplatesManage",

  /**
   * Notificações - Modelos de e-Mail - Editar Conteúdo
   * Edita o conteúdo HTML dos modelos de e-mail; necessário também possuir permissão de gerenciamento dos modelos de mensagem para que esta permissão tenha efeito.
   */
  NotificationEmailTemplatesContentEdit = "NotificationEmailTemplatesContentEdit",

  /**
   * Customizações do Sistema - Configurar.
   * Modifica configurações de personalização do sistema.
   */
  SystemCustomizationConfigure = "SystemCustomizationConfigure",

  /**
   * Customizações do Sistema - Premiações.
   * Modifica configurações de personalização das premiações.
   */
  SystemGamificationConfigure = "SystemGamificationConfigure",

  /**
   * Autenticação de Usuários - Configurar.
   * Modifica configurações de autenticação de usuários.
   * Configura integrações para acesso de usuários (SAML e SSO).
   */
  SystemAuthConfigure = "SystemAuthConfigure",

  /**
   * Cadastro e Acesso de Usuários - Configurar.
   * Configura opções de cadastro e acesso de usuários ao sistema.
   * Inclui acesso aos cadastros de termos de uso, motivos de bloqueio, tipos de gerentes, locais de trabalho e horários de acesso.
   */
  SystemUserOptionsConfig = "SystemUserOptionsConfig",

  /**
   * Usuário pode editar o código das mensagens de notificação.
   */
  SystemNotificationCode = "SystemNotificationCode",

  /**
   * Carga de Dados - Executar
   */
  SystemDataLoadExecute = "SystemDataLoadExecute",

  /**
   * Carga de Dados - Configurar
   */
  SystemDataLoadConfigure = "SystemDataLoadConfigure",

  /**
   * Termos de Uso - Configurar
   */
  SystemTermsConfigure = "SystemTermsConfigure",

  /**
   * Página Bem-Vindo - Configurar
   */
  SystemWelcomeConfigure = "SystemWelcomeConfigure",

  /**
   * Gamificação - Visualizar Painel de Informações
   */
  SystemGamificationViewDashboard = "SystemGamificationViewDashboard",

  /**
   * Relatórios Customizados - Visualizar
   */
  SystemCustomReportsView = "SystemCustomReportsView",

  /**
   * Consumo e Cobrança - Visualizar
   */
  SystemBillingViewDashboard = "SystemBillingViewDashboard",

  /**
   * Auditoria - Exclusão de Registros - Visualizar
   */
  SystemAuditDelete = "SystemAuditDelete",

  /**
   * Auditoria - Log de Processos - Visualizar
   */
  SystemAuditProcessLog = "SystemAuditProcessLog",

  /**
   * Auditoria - Carga de Dados - Baixar Arquivo
   */
  SystemAuditDataLoad = "SystemAuditDataLoad",

  /**
   * Disparo de Mensagens - Enviar
   * Pode editar e disparar mensagens de e-mail a uma seleção de usuários do sistema.
   */
  SystemSendMessage = "SystemSendMessage",



  /**
   * Conhecimento - Administrar Canais.
   * Pode criar, editar, excluir, juntar canais  de conhecimento.
   * Pode administrar canais cujo proprietário está associado aos grupos/unidades indicados pela restrição da permissão.
   * OBS: usuário administrador, não tem as permissões de um membro do canal, não pode ver publicações restritas, nem fazer publicações no canal, porém pode se auto-adicionar como um membro do canal e assim passar a ter todos os direitos de um membro.
  */
  KnowledgeChannelsAdmin = "KnowledgeChannelsAdmin",

  /**
   * Pode criar novos canais.
   * Pode editar e excluir canais que criou.
   * Por padrão torna-se o membro proprietário dos canais que criar.
   * - Restrições
   *   Objetos criados pelo usuário
   * OBS: não existe um gerente global para todos os canais; ao invés disso, usuários com a permissão KnowledgeChannelsAdmin podem interferir em
   *      canais criados por usuários de determinados grupos/units e se auto-cadastrar como membro gerente destes canais quando necessário.
  */
  KnowledgeChannelsManager = "KnowledgeChannelsManager",

  /**
   * Conhecimento - Publicador Institucional
   * Pode criar publicações marcadas como institucionais (nos canais onde é colaborador ou gerente).
  */
  KnowledgeInstitutionalPublisher = "KnowledgeInstitutionalPublisher",

  /**
   * Conhecimento - Aplicar Rótulos Restritos
   * Pode aplicar rótulos marcados como de uso restrito nas publicações (nos canais onde é colaborador ou gerente).
  */
  KnowledgeApplyRestrictedStickers = "KnowledgeApplyRestrictedStickers",

  /**
   * Conhecimento - Gestor de Engajamento
   * Pode gerenciar vídeos curtos.
   * Pode promover tópicos e canais.
   * Pode editar filtros rápidos disponíveis.
   * Pode gerenciar premiações e medalhas
  */
  KnowledgeEngagementManager = "KnowledgeEngagementManager",

  /**
   * Conhecimento - Identificar visualizadores de publicações.
   * Pode identificar quais usuários visualizaram  qualquer publicação a que tem acesso.
  */
  KnowledgeIdentifyPublicationViewers = "KnowledgeIdentifyPublicationViewers",

  /**
   * Conhecimento - Gerenciar Lixeira.
   * Pode recuperar publicações removidas por outros usuários.
   * Pode excluir definitivamente publicações removidas por outros usuários.
  */
  KnowledgeManageTrashCan = "KnowledgeManageTrashCan",

  /**
   * Conhecimento - Administrar Sistema.
   * Pode alterar opções gerais do módulo de conhecimento e colaboração.
   * Pode promover vídeos curtos.
   * Pode promover tópicos e canais.
   * Pode editar filtros rápidos disponíveis.
   * Pode gerenciar a lixeira (publicações removidas).
  */
  KnowledgeAdmin = "KnowledgeAdmin",

  /**
   * Conhecimento - Visualizar Painel de Informações
   * Pode acessar dashboard "painel de informações" com informações e análises de publicações e engajamento
   */
  KnowledgeViewDashboard = "KnowledgeViewDashboard",

  /*
  * Conhecimento - Publicar Arquivos em Lote
  * Pode realizar publicações em lote, onde uma publicação separada será criada para cada arquivo dentro de um pacote zip importado pelo usuário.
  */
  KnowledgeBatchPublisher = "KnowledgeBatchPublisher",

  /**
   * Conhecimento - Pode realizar uma postagem.
   * Esta permissão é calculada com base nos Canais que o usuário pode publicar.
   */
  KnowledgePost = "KnowledgePost",

  /**
   * Conhecimento - Pode gerenciar algum canal.
   * Esta permissão é calculada com base nos Canais que o usuário pode gerenciar.
   */
  KnowledgeManagesSomeChannel = "KnowledgeManagesSomeChannel",

  /**
   * Treinamentos - Administração
   */
  TrainingAdmin = "TrainingAdmin",

  /**
   * Treinamentos - Gerenciar
   */
  TrainingManage = "TrainingManage",

  /**
   * Treinamentos - Atualizar
   */
  TrainingUpdate = "TrainingUpdate",

  /**
   * Treinamentos - Gerenciar Turmas
   */
  TrainingManageClass = "TrainingManageClass",

  /**
   * Treinamentos - Aplicar Rótulos Restritos.
   * Pode aplicar rótulos marcados como restritos em qualquer treinamento a que tenha acesso.
   */
  TrainingApplyRestrictedStickers = "TrainingApplyRestrictedStickers",

  /**
   * Treinamentos - Supervisionar Opiniões sobre Treinamentos
   * Pode excluir avaliações/opiniões feitas por usuários inscritos em treinamentos
   */
  TrainingReviewSupervisor = "TrainingReviewSupervisor",

  /**
   * Treinamentos - Pode inscrever usuários em qualquer treinamento/turma disponível, MESMO QUE usuários não façam parte do público-alvo.
   */
  TrainingManageEnrollments = "TrainingManageEnrollments",

  /**
   * Treinamentos - Pode inscrever usuários em qualquer treinamento/turma disponível, DESDE QUE usuários façam parte do público-alvo.
   */
  TrainingManageEnrollmentsTargetAudience = "TrainingManageEnrollmentsTargetAudience",

  /**
  * Treinamentos - Pode revogar, excluir ou isentar inscrição de usuários (limitado pelas restrições da permissão) em qualquer treinamento.
  */
  TrainingRevokeExemptExcludeEnrollments = "TrainingRevokeExemptExcludeEnrollments",

  /**
  * Treinamentos - Coordenar Treinamentos
  */
  TrainingCoordinate = "TrainingCoordinate",

  /**
  * Treinamentos - Visualizar Alocação de Instrutores
  */
  TrainingViewInstructorAllocation = "TrainingViewInstructorAllocation",

  /**
  * Treinamentos - Coodenar treinamento específico (VIRTUAL). Se usuário é coordenador de alguns treinamento.
  */
  TrainingSpecificCoordinate = "TrainingSpecificCoordinate",

  /**
  * Treinamentos - Coodenar treinamento específico (VIRTUAL). Se usuário é coordenador de alguns treinamento e nas configurações permitir que coordenadores podem inscrever usuários.
  */
  TrainingSpecificCoordinateEnrollUsers = "TrainingSpecificCoordinateEnrollUsers",

  /**
  * Treinamentos - Monitorar e supervisionar treinamentos (VIRTUAL) - Usuário for instrutor ou coordenador em pelo menos 1 treinamento.
  */
  TrainingSpecificCoordinateOrInstructor = "TrainingSpecificCoordinateOrInstructor",

  /**
   * Treinamentos - Visualizar Índice de Treinamento
   * Pode acessar dashboard do índice de treinamento
   */
  TrainingViewTrainingIndex = "TrainingViewTrainingIndex",

  /**
   * Treinamentos - Visualizar Painel de Informações
   * Pode acessar dashboard "painel de informações" com informações e análises de treinamentos e desafios de conhecimento
   */
  TrainingViewDashboard = "TrainingViewDashboard",

  /**
   * Treinamentos - Criar Planos de Desenvolvimento
   * Pode criar planos de desenvolvimento
   */
  TrainingCreateDevelopmentPlan = "TrainingCreateDevelopmentPlan",

  /**
   * Treinamentos - Importar Histórico de Inscrições
   * Pode importar histórico de inscrições para todos os tipos de curso; válido apenas se usuário também possuir a permissão Treinamentos - Gerenciar Inscrições.
   */
  TrainingEnrollmentBatchLoadAll = "TrainingEnrollmentBatchLoadAll",

  /**
   * Treinamento - Importar Histórico de Inscrições em Cursos Externos
   * Pode importar histórico de inscrições apenas para cursos externos; válido apenas se usuário também possuir a permissão Treinamentos - Gerenciar Inscrições.
   */
  TrainingEnrollmentBatchLoadExternal = "TrainingEnrollmentBatchLoadExternal",

  /**
   * Treinamentos - Importar em Lote
   * Pode importar todos os tipos de treinamento em lote; válido apenas se usuário também possuir a permissão Treinamentos - Gerenciar.
   */
  TrainingBatchLoadAll = "TrainingBatchLoadAll",

  /**
   * Treinamentos - Importar em Lote Cursos Externos
   * Pode importar apenas cursos externos em lote; válido apenas se usuário também possuir a permissão Treinamentos - Gerenciar.
   */
  TrainingBatchLoadExternal = "TrainingBatchLoadExternal",

  /**
   * Avaliações - Gerenciar Banco de Questões.
   */
  AssessmentManageQuestionBank = "AssessmentManageQuestionBank",

  /**
   * Avaliações - Gerenciar Banco de Provas.
   */
  AssessmentManageEvaluation = "AssessmentManageEvaluation",

  /**
   * Avaliações - Gerenciar Banco de Pesquisas.
   */
  AssessmentManageSurvey = "AssessmentManageSurvey",

  /**
   * Avaliações - Aplicar Pesquisas.
   */
  AssessmentApplySurvey = "AssessmentApplySurvey",

  /**
   * Avaliações - Aplicar Pesquisas.
   */
  AssessmentSuperviseSurvey = "AssessmentSuperviseSurvey",

  /**
   * Avaliações - Gerenciar Testes de Conhecimento
   */
  AssessmentManageKnowledgeTest = "AssessmentManageKnowledgeTest",

  /**
   * Avaliações - Se o úsuário tem permissão específica para correção de questões dissertativas.
   * Esta é uma permissão VIRTUAL (calculada)
   */
  AssessmentSpecificPendingCorrection = "AssessmentSpecificPendingCorrection",

  /**
   * Core: Usuário é gerente de outro usuário.
   * Esta é uma permissão VIRTUAL (calculada)
   */
  UserIsManager = "UserIsManager",

  /**
   * Core: Usuário pode criar relatórios.
   * Esta é uma permissão VIRTUAL (calculada)
   */
  ReportCreator = "ReportCreator"
}

export class PermissionExplorer {
  private permissions: string[];
  private userType: UserType;

  constructor(permissions: string[], userType: UserType) {
    this.permissions = permissions ?? [];
    this.userType = userType;
  }

  get isAdmin() {
    return this.userType == UserType.Admin;
  }

  hasOne(permissions: string[]) {
    return permissions.filter((v) => this.permissions.includes(v)).length > 0;
  }

  hasAll(permissions: string[]) {
    return permissions.filter((v) => this.permissions.includes(v)).length == permissions.length;
  }

  get canEditProfile() {
    return this.hasOne(
      [
        CorePermissions.ProfileUpdatePersonal,
        CorePermissions.ProfileUpdateLocal,
        CorePermissions.ProfileUpdatePhoto,
        CorePermissions.ProfileUpdateKnowledge,
        CorePermissions.ProfileUpdateCredentials,
        CorePermissions.ProfileManageFiles,
        CorePermissions.ProfileAddFiles,
        CorePermissions.ProfileViewFiles,
        CorePermissions.ProfileUpdateName
      ]
    );
  }

  get canViewSetup() {
    return this.permissions.includes(CorePermissions.UsersManage)
      || this.permissions.includes(CorePermissions.UsersUpdate)
      || this.permissions.includes(CorePermissions.UsersChangePassword)
      || this.permissions.includes(CorePermissions.UsersBlockOrSetAbsence)
      || this.permissions.includes(CorePermissions.UsersImpersonate)
      || this.permissions.includes(CorePermissions.UsersAssignRole)
      || this.permissions.includes(CorePermissions.UnitsManage)
      || this.permissions.includes(CorePermissions.UnitsUpdate)
      || this.permissions.includes(CorePermissions.TopicsManage)
      || this.permissions.includes(CorePermissions.GroupsManageDynamic)
      || this.permissions.includes(CorePermissions.GroupsManageStatic)
      || this.permissions.includes(CorePermissions.GroupsUpdate)
      || this.permissions.includes(CorePermissions.CustomFieldsManage)
      || this.permissions.includes(CorePermissions.NotificationEmailTemplatesManage)
      || this.permissions.includes(CorePermissions.TagsManage)
      || this.permissions.includes(CorePermissions.TagsBlackListManage)
      || this.permissions.includes(CorePermissions.StickersManage)
      || this.permissions.includes(CorePermissions.SystemAuditProcessLog)
      || this.permissions.includes(CorePermissions.SystemTermsConfigure)
      || this.permissions.includes(CorePermissions.CalendarManage)
      || this.permissions.includes(CorePermissions.AccessHoursManage)
      || this.permissions.includes(CorePermissions.SystemUserOptionsConfig)
      || this.permissions.includes(CorePermissions.SystemAuthConfigure)
      || this.permissions.includes(CorePermissions.SystemCustomizationConfigure)
      || this.permissions.includes(CorePermissions.SystemDataLoadConfigure)
      || this.permissions.includes(CorePermissions.SystemGamificationConfigure)
      || this.permissions.includes(CorePermissions.SystemWelcomeConfigure);
  }

  get canViewAdvDashboards() {
    return this.hasOne(
      [
        CorePermissions.UserIsManager,
        CorePermissions.TrainingViewDashboard,
        CorePermissions.KnowledgeViewDashboard,
        CorePermissions.SystemGamificationViewDashboard,
        CorePermissions.TrainingViewTrainingIndex,
        CorePermissions.SystemCustomReportsView,
        CorePermissions.SystemBillingViewDashboard
      ]
    );
  }
}
